import React from 'react';

const MenuOrdericon = ({ active }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={active}>
      <mask id="mask0_13923_28473" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" />
      </mask>
      <g mask="url(#mask0_13923_28473)">
        <path d="M6.88455 21V12.1409C6.07304 11.9697 5.38936 11.5697 4.83352 10.9407C4.27784 10.3118 4 9.56135 4 8.68946V2H5.49978V8.68946H6.88455V2H8.38458V8.68946H9.76935V2H11.2691V8.68946C11.2691 9.56135 10.9913 10.3118 10.4356 10.9407C9.87977 11.5697 9.19609 11.9697 8.38458 12.1409V21H6.88455ZM16.5 21V13.2051H13.7694V6.62821C13.7694 5.41156 14.1703 4.35632 14.9722 3.46251C15.774 2.5687 16.7833 2.08745 18 2.01876V21H16.5Z" />
      </g>
    </svg>
  );
};

export default MenuOrdericon;
